import { gql } from '@apollo/client'

export const GET_USER_LIST = gql`
    query SearchUser(
        $userPool: USER_POOL!
        $searchString: String
        $searchUserId: String
        $role: String
        $isActive: Boolean
        $page: PageInput!
    ) {
        searchUser(
            user_pool: $userPool
            search_string: $searchString
            id: $searchUserId
            role: $role
            is_active: $isActive
            page: $page
        ) {
            code
            success
            message
            total_count
            users {
                id
                email
                user_info {
                    phone_number
                    phone_number_verified
                    given_name
                    family_name
                    nationality_code
                    date_of_birth
                    locale
                    photo {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                user_roles
                cognito_status
                additional_info {
             attachments {
                                document_number
                                document_type 
                                document {
                                    file_name
                                    size
                                    mime_type
                                    s3_key
                                }
                            }
                    job_title
                    document_number
                    document_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    document {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                    profile_photo {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                is_active
            }
        }
    }
`

// Dropdown for User List
export const GET_USER_NAMES = gql`
    query SearchUser(
        $userPool: USER_POOL!
        $searchString: String
        $searchUserId: String
        $role: String
        $isActive: Boolean
        $page: PageInput!
    ) {
        searchUser(
            user_pool: $userPool
            search_string: $searchString
            id: $searchUserId
            role: $role
            is_active: $isActive
            page: $page
        ) {
            code
            success
            message
            total_count
            users {
                id
                user_info {
                    given_name
                    family_name
                }
                user_roles
                is_active
            }
        }
    }
`

export const GET_USER_DETAILS = gql`
    query GetUserDetails($userId: NonEmptyString!) {
        getUserDetails(user_id: $userId) {
            success
            code
            message
            user {
                id
                email
                user_info {
                    given_name
                    family_name
                    phone_number
                    locale
                }
                user_roles
                additional_info {
               attachments {
                                document_number
                                document_type 
                                document {
                                    file_name
                                    size
                                    mime_type
                                    s3_key
                                }
                            }
                    profile_photo {
                        s3_key
                        file_name
                        size
                        mime_type
                    }
                }
            }
        }
    }
`

export const GET_ADMIN_USER_ROLES = gql`
    query GetAdminUserRoles {
        getAdminUserRoles {
            code
            success
            message
            total_count
            roles {
                role_code
                country
                description {
                    en
                    ar
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`
